import { SlDiamond } from 'react-icons/sl';
import { BsLaptop } from 'react-icons/bs';
import { GiGraduateCap } from 'react-icons/gi';

import { FaLaptopCode, FaReact, FaAws, FaNodeJs, FaGithub } from "react-icons/fa";
import { SiJavascript, SiTypescript, SiCplusplus, SiNextdotjs, SiTailwindcss, SiExpress, SiMongodb, SiPostgresql, SiPrisma, SiFramer } from "react-icons/si";
import { TbBrandReactNative } from "react-icons/tb";

export const skills = [
    {
        id : 1,
        icon: <SlDiamond/> ,
        heading: "visual design",
        description : "Create user interface design with unique & modern ideas",
    },
    {
        id : 2,
        icon: <BsLaptop/> ,
        heading: "Design Prototype",
        description : "Create advance design prototype with Figma Apps",
    },
    {
        id : 3,
        icon: <GiGraduateCap/> ,
        heading: "UX Research",
        description : "Create digital user products with updated ideas",
    },
]

export const skillsPrgressData = [
    { id: 1, skill: "Design", completed: "80%" },
    { id: 2, skill: "HTML", completed: "98%" },
    { id: 3, skill: "CSS", completed: "88%" },
    { id: 4, skill: "JavaScript", completed: "80%" },
    { id: 5, skill: "MERN STACK", completed: "88%" },
]

export const skillsData = [
    { name: "JavaScript", icon: <SiJavascript color="#F7DF1E" /> },
    { name: "TypeScript", icon: <SiTypescript color="#3178C6" /> },
    { name: "C/C++", icon: <SiCplusplus color="#00599C" /> },
    { name: "React.js", icon: <FaReact color="#61DAFB" /> },
    { name: "Next.js", icon: <SiNextdotjs className="dark:text-white" /> },
    { name: "React Native", icon: <TbBrandReactNative color="#61DAFB" /> },
    { name: "Tailwind CSS", icon: <SiTailwindcss color="#06B6D4" /> },
    { name: "ShadCN", icon: <SiNextdotjs className="dark:text-white" /> },
    { name: "Node.js", icon: <FaNodeJs color="#339933" /> },
    { name: "Express.js", icon: <SiExpress className="dark:text-white" /> },
    { name: "Hono.js", icon: <SiJavascript color="#E36002" /> },
    { name: "AWS Lambda", icon: <FaAws color="#FF9900" /> },
    { name: "AWS S3", icon: <FaAws color="#FF9900" /> },
    { name: "AWS RDS", icon: <FaAws color="#FF9900" /> },
    { name: "MongoDB", icon: <SiMongodb color="#47A248" /> },
    { name: "PostgreSQL", icon: <SiPostgresql color="#4169E1" /> },
    { name: "Prisma", icon: <SiPrisma className="dark:text-white" /> },
    { name: "Drizzle ORM", icon: <SiTypescript color="#C5F74F" /> },
    { name: "Git & GitHub", icon: <FaGithub className="dark:text-white" /> },
    { name: "Framer Motion", icon: <SiFramer className="dark:text-white" /> },
];

// Experience Data

export const experience = [
    {
        "heading": "Software Developer",
        "subHeading": "Sensationz Performing Arts",
        "desc": "Built and deployed production-grade React Native applications for Android and iOS, serving 10,000+ downloads and 5,000+ daily active users. Developed full-stack features using React Native, Node.js, Hono.js, MongoDB, and PostgreSQL, including 100+ optimized RESTful APIs. Integrated Razorpay, RevenueCat, Firebase Cloud Messaging (FCM), and AWS services including S3, Lambda, and RDS for payments, subscriptions, push notifications, storage, serverless workloads, and database infrastructure. Built and maintained admin dashboards with role-based access control, user/course management, order workflows, and secure authentication.",
        "date": "October 2025 - Present",
        "icon": <FaLaptopCode />,
    },
    {
        "heading": "Full Stack Developer",
        "subHeading": "Techkriti Group",
        "desc": "Delivered robust full-stack web solutions using MongoDB, Express.js, React, and Node.js. Enhanced interface responsiveness and managed deployment & hosting setups.",
        "date": "February 2025 - August 2025",
        "icon": <FaReact />,
    },
]